export const
    COMPANY_CHANGE_SELECTED_ROW = "COMPANY_CHANGE_SELECTED_ROW",
    COMPANY_CHANGE_TABLE_PAGE = "COMPANY_CHANGE_TABLE_PAGE",
    COMPANY_CHANGE_TEXT_FOR_SEARCHING = "COMPANY_CHANGE_TEXT_FOR_SEARCHING",
    COMPANY_SEARCH_COMPANIES_BY_TAX_FAILURE = "COMPANY_SEARCH_COMPANIES_BY_TAX_FAILURE",
    COMPANY_SEARCH_COMPANIES_BY_TEXT_FAILURE = "COMPANY_SEARCH_COMPANIES_BY_TEXT_FAILURE",
    COMPANY_SEARCH_COMPANIES_BY_TAX_REQUEST = "COMPANY_SEARCH_COMPANIES_BY_TAX_REQUEST",
    COMPANY_SEARCH_COMPANIES_BY_TAX_SUCCESS = "COMPANY_SEARCH_COMPANIES_BY_TAX_SUCCESS",
    COMPANY_SEARCH_COMPANIES_BY_TEXT_REQUEST = "COMPANY_SEARCH_COMPANIES_BY_TEXT_REQUEST",
    COMPANY_SEARCH_COMPANIES_BY_TEXT_SUCCESS = "COMPANY_SEARCH_COMPANIES_BY_TEXT_SUCCESS",
    COMPANY_SET_TO_INITIAL_STATE = "COMPANY_SET_TO_INITIAL_STATE";



// WEBPACK FOOTER //
// ./src/types/Company.js